import { render, staticRenderFns } from "./default.vue?vue&type=template&id=665db71b"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotMainHeader: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Organisms/MainHeader/MainHeader.vue').default,HotBreadcrumbList: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Molecules/BreadcrumbList/BreadcrumbList.vue').default,HotContainer: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Templates/Container/Container.vue').default,HotHcmFooter: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Organisms/HcmFooter/HcmFooter.vue').default})
